import { createContext, useEffect } from "react"
import { useSearchParams } from "react-router-dom"

const ReferralContext = createContext<undefined>(undefined)

export const ReferralProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const referral = searchParams.get("referral")
    if (referral) {
      sessionStorage.setItem("referral", referral)
    }
  }, [searchParams])

  return <ReferralContext.Provider value={undefined}>{children}</ReferralContext.Provider>
}
